import styled, { css } from 'styled-components';
import MenuItem from '@material-ui/core/MenuItem';
import RefreshOutlined from '@material-ui/icons/RefreshOutlined';
import SwapHorizOutlined from '@material-ui/icons/SwapHorizOutlined';
import MaterialEdit from '@material-ui/icons/Edit';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';
import React, { useCallback, useState } from 'react';
import Menu from '@material-ui/core/Menu';
import KebabMenuIcon from '../../../../../../SolvPatternLibrary/Icons/KebabMenu';
import { fontFamily, fontSize } from '../../../../../../../constants/text';
import { colors } from '../../../../../../../constants/colors';
import { analyticsTrackEvent } from '../../../../../../../core/analytics';
import {
  PROFILE_EDIT_INSURANCE,
  PROFILES_TOUCH_ADD_INSURANCE,
} from '../../../../../../../core/analytics/events';
import useSelectRemoveInsurance from '../hooks/useSelectRemoveInsurance';
import history from '../../../../../../../core/history';
import useSelectRefreshInsurance from '../hooks/useSelectRefreshInsurance';

const ListItem = styled(MenuItem).withConfig({ componentId: 'sc-myz930-0' })`
  color: ${colors.squid};
  font-size: ${fontSize.mediumSmall};
  font-family: ${fontFamily.book};
  padding: 8px 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const IconCss = css`
  width: 15px;
  margin-right: 5px;
`;

// @ts-expect-error ts-migrate(2769) FIXME: Type 'readonly SimpleInterpolation[]' is not assig... Remove this comment to see the full error message
const Refresh = styled(RefreshOutlined).withConfig({ componentId: 'sc-myz930-1' })(IconCss);
// @ts-expect-error ts-migrate(2769) FIXME: Type 'readonly SimpleInterpolation[]' is not assig... Remove this comment to see the full error message
const Replace = styled(SwapHorizOutlined).withConfig({ componentId: 'sc-myz930-2' })(IconCss);
// @ts-expect-error ts-migrate(2769) FIXME: Type 'readonly SimpleInterpolation[]' is not assig... Remove this comment to see the full error message
const Edit = styled(MaterialEdit).withConfig({ componentId: 'sc-myz930-3' })(IconCss);
// @ts-expect-error ts-migrate(2769) FIXME: Type 'readonly SimpleInterpolation[]' is not assig... Remove this comment to see the full error message
const Remove = styled(DeleteOutlinedIcon).withConfig({ componentId: 'sc-myz930-4' })(IconCss);

type Props = {
  userProfileId: string;
};

const UpdateInsuranceMenu = (props: Props) => {
  const { userProfileId } = props;

  const [anchorEl, setAnchorEl] = useState(null);
  const handleOpenMenu = (event: any) => setAnchorEl(event.currentTarget);
  const handleCloseMenu = () => setAnchorEl(null);

  const removeInsurance = useSelectRemoveInsurance(userProfileId);
  const refreshInsurance = useSelectRefreshInsurance(userProfileId, handleCloseMenu);

  const onReplaceInsurance = useCallback(
    (event) => {
      event.stopPropagation();
      const trackingProperties = { userProfileId, insuranceType: 'medical' };
      analyticsTrackEvent(PROFILES_TOUCH_ADD_INSURANCE, trackingProperties);
      history.push(`/add-insurance/up?p=${userProfileId}`);
    },
    [userProfileId]
  );

  const onEditInsurance = useCallback(
    (event) => {
      event.stopPropagation();
      const trackingProperties = { userProfileId };
      analyticsTrackEvent(PROFILE_EDIT_INSURANCE, trackingProperties);
      history.push(`/add-insurance/up?p=${userProfileId}`);
    },
    [userProfileId]
  );

  return (
    <div>
      <KebabMenuIcon onClick={handleOpenMenu} />

      <Menu anchorEl={anchorEl} onClose={handleCloseMenu} open={!!anchorEl}>
        <ListItem onClick={refreshInsurance}>
          <Refresh />
          Refresh
        </ListItem>

        <ListItem onClick={onReplaceInsurance}>
          <Replace />
          Replace
        </ListItem>

        <ListItem onClick={onEditInsurance}>
          <Edit />
          Edit
        </ListItem>

        <ListItem onClick={removeInsurance}>
          <Remove />
          Remove
        </ListItem>
      </Menu>
    </div>
  );
};

export default UpdateInsuranceMenu;
